import PropTypes from 'prop-types'
import React from 'react'
import config from 'SRC/config/config.yaml'

export const AddPhoneBtn = ({onClick}) =>
  <a className='dodaj-model-btn' href='javascript:void(0)' onClick={onClick}>
    <span className='add-model'>[+]</span> {config.updateProfileForm.contact.addPhoneText}
  </a>

AddPhoneBtn.propTypes = {
  onClick: PropTypes.func.isRequired
}
